

export class Study {
    Id: number;
    Name: string;

    constructor(id: number, name: string) { this.Id = id; this.Name = name; }

    static GetStudyName(id: number): string {
        switch (id) {
            case (9): return "REVERSE-LC";
            default: return "Unknown";
        }
    }

    //sorts in-place, with Infrastructure and Unknown at end of list
    static SortByName(list: Study[]): void {
        list.sort((a: Study, b: Study) => {
            return a.Name.localeCompare(b.Name); 
        });
    }

    static GetStudiesToShow(appendixIds: number[]): number[] {
        let studiesToShow: number[] = [];

        if (appendixIds.includes(1)) { studiesToShow.push(2); } //RVLC 

        return studiesToShow;
    }
}